import { JetView } from 'webix-jet';
import { allpayments } from 'models/allpayments';
import { devConfig } from 'config/config';

/**
 * Class representing the table deposit report view.
 * @extends JetView
 */
export default class tableDepositReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        var direction = false; // Variable to track sorting direction
        var vthis = this; // Reference to the current instance

        // Extend the summTreeColumn filter to calculate and display summary values
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable to hold the formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    // Format the result based on the column ID
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Update the node with the formatted result
                },
            },
            webix.ui.datafilter.summColumn,
        );

        // Extend the mySummColumn filter to calculate and display summary values for paginated data
        webix.ui.datafilter.mySummColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable to hold the formatted result
                    var size = $$('datatable4').getPager().config.size; // Get the page size
                    var page = $$('datatable4').getPage(); // Get the current page
                    var first = size * page; // Calculate the first item index
                    var last = first + size - 1; // Calculate the last item index
                    var count = 0; // Counter for items processed
                    master.data.each(function (obj) {
                        if (count >= first && count <= last) {
                            result += parseFloat(obj[value.columnId]); // Sum values within the current page
                        }
                        count++;
                    });
                    resultFormat = webix.i18n.priceFormat(result); // Format the result
                    node.firstChild.innerHTML = resultFormat; // Update the node with the formatted result
                },
            },
            webix.ui.datafilter.summColumn,
        );

        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable',
                            id: 'datatable4', // ID for the main data table
                            css: 'webix_header_border webix_data_border webix_footer_border',
                            columns: [
                                {
                                    id: 'detailTittle',
                                    header: '',
                                    width: 80,
                                    height: 25,
                                    tooltip: _('Detalles'), // Tooltip for details column
                                    template: function (obj) {
                                        // Template for rendering action icons based on permissions
                                        if (obj.State === 'A') {
                                            if (devConfig.getPermAction('depositRequestsShopDecline', 'Pay')) {
                                                if (devConfig.getPermAction('depositRequestsShopPrinter', 'Pay')) {
                                                    return (
                                                        "<span placeholder='Imprimir' class='webix_icon wxi-close printer prm-depositRequestsShopPrinter'></span><span class='webix_icon wxi-close details prm-depositRequestsShopPrinter'></span>" +
                                                        "<span placeholder='Pagar' class='webix_icon wxi-close icon-tranfer prm-depositRequestsShopPrinter'></span>"
                                                    );
                                                } else {
                                                    return (
                                                        "<span class='webix_icon wxi-close details prm-depositRequestsShopDecline'></span>" +
                                                        "<span placeholder='Pagar' class='webix_icon wxi-close icon-tranfer prm-depositRequestsShopDecline'></span>"
                                                    );
                                                }
                                            } else {
                                                if (devConfig.getPermAction('depositRequestsShopPrinter', 'Pay')) {
                                                    return "<span placeholder='Imprimir' class='webix_icon wxi-close printer prm-depositRequestsShopPrinter'></span><span class='webix_icon wxi-close details prm-depositRequestsShopPrinter'></span>";
                                                } else {
                                                    return "<span class='webix_icon wxi-close details'></span>";
                                                }
                                            }
                                        }
                                        if (devConfig.getPermAction('depositRequestsShopPrinter', 'Pay')) {
                                            return "<span placeholder='Imprimir' class='webix_icon wxi-close printer prm-depositRequestsShopPrinter'></span><span class='webix_icon wxi-close details prm-depositRequestsShopPrinter'></span>";
                                        } else {
                                            return "<span class='webix_icon wxi-close details'></span>";
                                        }
                                    },
                                    footer: 'Total:', // Footer label for the details column
                                },
                                { id: 'Id', header: 'ID', width: 100 }, // Column for ID
                                {
                                    id: 'ClientId',
                                    header: _('ID Usuario'),
                                    width: 100,
                                }, // Column for User ID
                                {
                                    id: 'CreatedLocal',
                                    header: _('Fecha de Creación'), // Column for creation date
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 150,
                                    format: dateFormat, // Date format for display
                                },
                                {
                                    id: 'Provider',
                                    header: _('Proveedor'),
                                    width: 150,
                                }, // Column for Provider
                                {
                                    id: 'PaymentSystemName',
                                    header: _('Nombre Sistema Pasarela Pago'), // Column for Payment System Name
                                    width: 250,
                                },
                                {
                                    id: 'TypeName',
                                    header: _('Tipo'),
                                    width: 100,
                                }, // Column for Type
                                {
                                    id: 'CurrencyId',
                                    header: _('Moneda'),
                                    width: 100,
                                }, // Column for Currency
                                {
                                    id: 'Amount',
                                    header: _('Valor'), // Column for Amount
                                    width: 100,
                                    format: webix.i18n.priceFormat, // Format for price display
                                    exportType: 'number', // Export type for the column
                                    footer: { content: 'mySummColumn' }, // Footer content for summary
                                    editor: 'text', // Editor type for inline editing
                                },
                                {
                                    id: 'Commission',
                                    header: _('Comisión'), // Column for Commission
                                    width: 100,
                                    format: webix.i18n.priceFormat, // Format for price display
                                    exportType: 'number', // Export type for the column
                                    footer: { content: 'mySummColumn' }, // Footer content for summary
                                    editor: 'text', // Editor type for inline editing
                                },
                                {
                                    id: 'ModifiedLocal',
                                    header: _('Modificado'), // Column for Modified Date
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 150,
                                    format: dateFormat, // Date format for display
                                },
                                {
                                    id: 'State',
                                    header: _('Estado'), // Column for State
                                    options: [
                                        { id: '', value: _('None') },
                                        { id: 'A', value: _('Pagada') },
                                        { id: 'C', value: _('Cancelado') },
                                        { id: 'I', value: _('Inactivo') },
                                        { id: 'R', value: _('Rechazada') },
                                    ],
                                },
                                {
                                    id: 'ExternalId',
                                    header: _('External ID'),
                                    width: 150,
                                }, // Column for External ID
                                { id: 'Ip', header: 'IP', width: 150 }, // Column for IP
                                {
                                    id: 'CashDeskId',
                                    header: _('Recepcion de Efectivo'),
                                    width: 150,
                                }, // Column for Cash Desk ID
                            ],
                            onClick: {
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('deposit:id', [item.Id]); // Trigger event with item ID
                                    // Show details based on screen size
                                    if (screen.width < 500 || screen.height < 500) {
                                        $$('filterDetails').show();
                                    } else {
                                        $$('a5').scrollTo(0, 1000);
                                        $$('dColl').expand();
                                    }
                                },
                                printer: function (euv, id) {
                                    var vvthis = this; // Reference to the current instance
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea imprimir recibo?'), // Confirmation message
                                        ok: _('Imprimir'),
                                        cancel: _('Salir'),
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the clicked item
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/ReprintCoupons', // API endpoint for reprinting
                                                        '{ "Id":' + item.Id + '}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message('Error! '); // Error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var dat = JSON.parse(text); // Parse response data
                                                                if (dat.HasError) {
                                                                    webix.message({
                                                                        title: '¡Error!',
                                                                        type: 'alert-error',
                                                                        text: _(dat.AlertMessage), // Display error message
                                                                    });
                                                                } else {
                                                                    webix
                                                                        .ui({
                                                                            view: 'window',
                                                                            width: 450,
                                                                            height: 450,
                                                                            head: {
                                                                                view: 'toolbar',
                                                                                cols: [
                                                                                    {
                                                                                        view: 'label',
                                                                                        label: _(
                                                                                            'Seleccione tipo de factura',
                                                                                        ),
                                                                                        align: 'center',
                                                                                    },
                                                                                    {
                                                                                        view: 'icon',
                                                                                        icon: 'wxi-close',
                                                                                        click: function () {
                                                                                            this.getTopParentView().hide(); // Close the window
                                                                                        },
                                                                                    },
                                                                                ],
                                                                            },
                                                                            position: 'center',
                                                                            modal: true,
                                                                            body: {
                                                                                view: 'form',
                                                                                elements: [
                                                                                    {
                                                                                        cols: [
                                                                                            {
                                                                                                view: 'button',
                                                                                                value: _('POS'), // Button for POS invoice
                                                                                                click: function () {
                                                                                                    webix
                                                                                                        .ui({
                                                                                                            view: 'window',
                                                                                                            width: 500,
                                                                                                            height: 700,
                                                                                                            head: {
                                                                                                                view: 'toolbar',
                                                                                                                cols: [
                                                                                                                    {
                                                                                                                        view: 'label',
                                                                                                                        label: _(
                                                                                                                            'Factura',
                                                                                                                        ),
                                                                                                                    },
                                                                                                                    {
                                                                                                                        view: 'button',
                                                                                                                        label: 'X',
                                                                                                                        width: 100,
                                                                                                                        align: 'right',
                                                                                                                        click: "$$('windowfact2').close();", // Close the invoice window
                                                                                                                    },
                                                                                                                ],
                                                                                                            },
                                                                                                            id: 'windowfact2', // ID for the invoice window
                                                                                                            modal: true,
                                                                                                            position:
                                                                                                                'center',
                                                                                                            body: {
                                                                                                                rows: [
                                                                                                                    {
                                                                                                                        template:
                                                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Template for displaying PDF
                                                                                                                    },
                                                                                                                ],
                                                                                                            },
                                                                                                        })
                                                                                                        .show(); // Show the invoice window
                                                                                                    var reader =
                                                                                                        new FileReader(); // FileReader to read the PDF data
                                                                                                    reader.onload =
                                                                                                        function (
                                                                                                            event,
                                                                                                        ) {
                                                                                                            $$(
                                                                                                                'pdf',
                                                                                                            ).clear(); // Clear previous PDF data
                                                                                                            $$(
                                                                                                                'pdf',
                                                                                                            ).parse({
                                                                                                                data: event
                                                                                                                    .target
                                                                                                                    .result, // Parse the new PDF data
                                                                                                            });
                                                                                                        };

                                                                                                    function b64toBlob(
                                                                                                        b64Data,
                                                                                                        contentType,
                                                                                                        sliceSize,
                                                                                                    ) {
                                                                                                        contentType =
                                                                                                            contentType ||
                                                                                                            '';
                                                                                                        sliceSize =
                                                                                                            sliceSize ||
                                                                                                            512;
                                                                                                        var byteCharacters =
                                                                                                            atob(
                                                                                                                b64Data, // Decode base64 data
                                                                                                            );
                                                                                                        var byteArrays =
                                                                                                            [];
                                                                                                        for (
                                                                                                            var offset = 0;
                                                                                                            offset <
                                                                                                            byteCharacters.length;
                                                                                                            offset +=
                                                                                                                sliceSize
                                                                                                        ) {
                                                                                                            var slice =
                                                                                                                byteCharacters.slice(
                                                                                                                    offset,
                                                                                                                    offset +
                                                                                                                        sliceSize,
                                                                                                                );
                                                                                                            var byteNumbers =
                                                                                                                new Array(
                                                                                                                    slice.length,
                                                                                                                );
                                                                                                            for (
                                                                                                                var i = 0;
                                                                                                                i <
                                                                                                                slice.length;
                                                                                                                i++
                                                                                                            ) {
                                                                                                                byteNumbers[
                                                                                                                    i
                                                                                                                ] =
                                                                                                                    slice.charCodeAt(
                                                                                                                        i,
                                                                                                                    );
                                                                                                            }
                                                                                                            var byteArray =
                                                                                                                new Uint8Array(
                                                                                                                    byteNumbers,
                                                                                                                );
                                                                                                            byteArrays.push(
                                                                                                                byteArray,
                                                                                                            );
                                                                                                        }
                                                                                                        var blob =
                                                                                                            new Blob(
                                                                                                                byteArrays,
                                                                                                                {
                                                                                                                    type: contentType, // Create a Blob from the byte arrays
                                                                                                                },
                                                                                                            );
                                                                                                        return blob; // Return the Blob
                                                                                                    }

                                                                                                    var contentType =
                                                                                                        'application/pdf'; // Content type for PDF
                                                                                                    var b64Data =
                                                                                                        dat.PdfPOS; // Base64 data for POS PDF
                                                                                                    var blob =
                                                                                                        b64toBlob(
                                                                                                            b64Data,
                                                                                                            contentType,
                                                                                                        );
                                                                                                    var file =
                                                                                                        window.URL.createObjectURL(
                                                                                                            blob, // Create a URL for the Blob
                                                                                                        );
                                                                                                    document.querySelector(
                                                                                                        'iframe',
                                                                                                    ).src = file; // Set the iframe source to the Blob URL
                                                                                                    var printWindow =
                                                                                                        window.open(
                                                                                                            file,
                                                                                                            '',
                                                                                                            'width=800,height=500', // Open a new window for printing
                                                                                                        );
                                                                                                    printWindow.print(); // Trigger print
                                                                                                },
                                                                                            },
                                                                                            {
                                                                                                view: 'button',
                                                                                                value: _('CARTA'), // Button for CARTA invoice
                                                                                                click: function () {
                                                                                                    webix
                                                                                                        .ui({
                                                                                                            view: 'window',
                                                                                                            width: 500,
                                                                                                            height: 700,
                                                                                                            head: {
                                                                                                                view: 'toolbar',
                                                                                                                cols: [
                                                                                                                    {
                                                                                                                        view: 'label',
                                                                                                                        label: _(
                                                                                                                            'Factura',
                                                                                                                        ),
                                                                                                                    },
                                                                                                                    {
                                                                                                                        view: 'button',
                                                                                                                        label: 'X',
                                                                                                                        width: 100,
                                                                                                                        align: 'right',
                                                                                                                        click: "$$('windowfact2').close();", // Close the invoice window
                                                                                                                    },
                                                                                                                ],
                                                                                                            },
                                                                                                            id: 'windowfact2', // ID for the invoice window
                                                                                                            modal: true,
                                                                                                            position:
                                                                                                                'center',
                                                                                                            body: {
                                                                                                                rows: [
                                                                                                                    {
                                                                                                                        template:
                                                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Template for displaying PDF
                                                                                                                    },
                                                                                                                ],
                                                                                                            },
                                                                                                        })
                                                                                                        .show(); // Show the invoice window
                                                                                                    var reader =
                                                                                                        new FileReader(); // FileReader to read the PDF data
                                                                                                    reader.onload =
                                                                                                        function (
                                                                                                            event,
                                                                                                        ) {
                                                                                                            $$(
                                                                                                                'pdf',
                                                                                                            ).clear(); // Clear previous PDF data
                                                                                                            $$(
                                                                                                                'pdf',
                                                                                                            ).parse({
                                                                                                                data: event
                                                                                                                    .target
                                                                                                                    .result, // Parse the new PDF data
                                                                                                            });
                                                                                                        };

                                                                                                    function b64toBlob(
                                                                                                        b64Data,
                                                                                                        contentType,
                                                                                                        sliceSize,
                                                                                                    ) {
                                                                                                        contentType =
                                                                                                            contentType ||
                                                                                                            '';
                                                                                                        sliceSize =
                                                                                                            sliceSize ||
                                                                                                            512;
                                                                                                        var byteCharacters =
                                                                                                            atob(
                                                                                                                b64Data, // Decode base64 data
                                                                                                            );
                                                                                                        var byteArrays =
                                                                                                            [];
                                                                                                        for (
                                                                                                            var offset = 0;
                                                                                                            offset <
                                                                                                            byteCharacters.length;
                                                                                                            offset +=
                                                                                                                sliceSize
                                                                                                        ) {
                                                                                                            var slice =
                                                                                                                byteCharacters.slice(
                                                                                                                    offset,
                                                                                                                    offset +
                                                                                                                        sliceSize,
                                                                                                                );
                                                                                                            var byteNumbers =
                                                                                                                new Array(
                                                                                                                    slice.length,
                                                                                                                );
                                                                                                            for (
                                                                                                                var i = 0;
                                                                                                                i <
                                                                                                                slice.length;
                                                                                                                i++
                                                                                                            ) {
                                                                                                                byteNumbers[
                                                                                                                    i
                                                                                                                ] =
                                                                                                                    slice.charCodeAt(
                                                                                                                        i,
                                                                                                                    );
                                                                                                            }
                                                                                                            var byteArray =
                                                                                                                new Uint8Array(
                                                                                                                    byteNumbers,
                                                                                                                );
                                                                                                            byteArrays.push(
                                                                                                                byteArray,
                                                                                                            );
                                                                                                        }
                                                                                                        var blob =
                                                                                                            new Blob(
                                                                                                                byteArrays,
                                                                                                                {
                                                                                                                    type: contentType, // Create a Blob from the byte arrays
                                                                                                                },
                                                                                                            );
                                                                                                        return blob; // Return the Blob
                                                                                                    }

                                                                                                    var contentType =
                                                                                                        'application/pdf'; // Content type for PDF
                                                                                                    var b64Data =
                                                                                                        dat.Pdf; // Base64 data for CARTA PDF
                                                                                                    var blob =
                                                                                                        b64toBlob(
                                                                                                            b64Data,
                                                                                                            contentType,
                                                                                                        );
                                                                                                    var file =
                                                                                                        window.URL.createObjectURL(
                                                                                                            blob, // Create a URL for the Blob
                                                                                                        );
                                                                                                    document.querySelector(
                                                                                                        'iframe',
                                                                                                    ).src = file; // Set the iframe source to the Blob URL
                                                                                                    var printWindow =
                                                                                                        window.open(
                                                                                                            file,
                                                                                                            '',
                                                                                                            'width=800,height=500', // Open a new window for printing
                                                                                                        );
                                                                                                    printWindow.print(); // Trigger print
                                                                                                },
                                                                                            },
                                                                                        ],
                                                                                    },
                                                                                ],
                                                                            },
                                                                        })
                                                                        .show(); // Show the window for selecting invoice type
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                'icon-tranfer': function (euv, id) {
                                    var vvthis = this; // Reference to the current instance
                                    var item = vvthis.getItem(id); // Get the clicked item
                                    webix
                                        .modalbox({
                                            id: 'modalAgent',
                                            title: _('¿ Qué desea realizar ?'), // Modal title
                                            buttons: ['Rechazar Depósito', 'Cancelar'], // Modal buttons
                                            text: '',
                                            width: 200,
                                        })
                                        .then(function (result) {
                                            var state; // Variable to hold the new state
                                            switch (result) {
                                                case '0':
                                                    state = '1'; // Set state to '1' for rejection
                                                    break;
                                            }
                                            console.log(result); // Log the result
                                            if (result === '0') {
                                                var tthis = this; // Reference to the current instance
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Financial/ActionCouponsUser', // API endpoint for action
                                                        '{ "Id":' + item.Id + ', "State":"' + state + '"}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message('Error! '); // Error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var data = JSON.parse(text); // Parse response data
                                                                if (data.HasError) {
                                                                    webix.message(
                                                                        'No se proceso la solicitud. Comunicarse con soporte. ', // Error message
                                                                    );
                                                                    tthis.getTopParentView().hide(); // Close the modal
                                                                } else {
                                                                    item.State = 'I'; // Update item state
                                                                    webix.message(
                                                                        'Se ha se procesado la solicitud satisfactoriamente. ', // Success message
                                                                    );
                                                                    tthis.getTopParentView().hide(); // Close the modal
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        });
                                },
                            },
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox);
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>', // Show no data overlay
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            footer: true, // Enable footer
                            math: true, // Enable math calculations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                        {
                            type: 'wide',
                            scrollY: screen.width < 820 ? false : true, // Enable vertical scrolling based on screen width
                            view: 'treetable',
                            id: 'datatable2', // ID for the tree table
                            css: 'webix_header_border webix_data_border webix_footer_border',
                            columns: [
                                {
                                    id: 'CreatedLocal',
                                    header: _('Fecha de Creación'), // Column for creation date
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 220,
                                    format: dateFormat, // Date format for display
                                    template: function (obj, common) {
                                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Grouping template
                                        return obj.CreatedLocal; // Return creation date
                                    },
                                },
                                {
                                    id: 'PaymentSystemName',
                                    header: _('Nombre Sistema Pasarela Pago'), // Column for Payment System Name
                                    width: 250,
                                },
                                {
                                    id: 'CurrencyId',
                                    header: _('Moneda'),
                                    width: 100,
                                }, // Column for Currency
                                {
                                    id: 'Amount',
                                    header: _('Valor'), // Column for Amount
                                    width: 100,
                                    format: webix.i18n.priceFormat, // Format for price display
                                    exportType: 'number', // Export type for the column
                                    footer: { content: 'summTreeColumn' }, // Footer content for summary
                                },
                                {
                                    id: 'Commission',
                                    header: _('Comisión'), // Column for Commission
                                    width: 100,
                                    format: webix.i18n.priceFormat, // Format for price display
                                    exportType: 'number', // Export type for the column
                                    footer: { content: 'mySummColumn' }, // Footer content for summary
                                    editor: 'text', // Editor type for inline editing
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                console.log('count ' + this.count()); // Log the count of items
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox);
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>', // Show no data overlay
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            footer: true, // Enable footer
                            math: true, // Enable math calculations
                            loadahead: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: {
                                size: 10000, // Pager size
                                id: 'pagerr', // Pager ID
                            },
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        var gridppal = $$('datatable4'); // Main data table
        var grid2 = $$('datatable2'); // Secondary data table
        var url = devConfig.geturlApi() + 'es/Financial/GetCouponsWithdrawalsWithPaging2'; // API endpoint for main data
        var url2 = devConfig.geturlApi() + 'es/Financial/GetCouponsWithdrawalsWithPaging2'; // API endpoint for secondary data
        gridppal.hide(); // Hide the main data table initially
        var flag = false; // Flag for export operation
        $$('toolbar').hide(); // Hide the toolbar
        grid2.attachEvent('onAfterLoad', function () {
            // Group data in the secondary table after loading
            $$('datatable2').data.group({
                by: 'Provider',
                map: {
                    Partner: ['Partner'],
                    Provider: ['Provider'],
                    Country: ['Country'],
                    CountryIcon: ['CountryIcon'],
                    CurrencyId: ['CurrencyId'],
                    Amount: ['Amount', 'sum'],
                },
            });
            $$('datatable2').data.group({
                by: 'CurrencyId',
                map: {
                    Partner: ['Partner'],
                    Country: ['Country'],
                    CountryIcon: ['CountryIcon'],
                    CurrencyId: ['CurrencyId'],
                    Amount: ['Amount', 'sum'],
                },
            });
            $$('datatable2').data.group({
                by: function (obj) {
                    return "<i class='flags " + obj.CountryIcon + "'></i>" + obj.Country; // Group by country with icon
                },
                map: {
                    Partner: ['Partner'],
                    Country: ['Country'],
                    CountryIcon: ['CountryIcon'],
                    Amount: ['Amount', 'sum'],
                },
            });
            $$('datatable2').data.group({
                by: function (obj) {
                    return "<i class='partner " + obj.Partner + "'></i>"; // Group by partner with icon
                },
                map: {
                    Partner: ['Partner'],
                    Amount: ['Amount', 'sum'],
                },
            });
        });
        var filter = ''; // Variable to hold filter parameters
        this.on(this.app, 'depositReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters
            var string2 = ''; // Query string for sorting
            var providergroup = 0; // Flag for provider grouping
            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'IsDetails') {
                    if (object[i][1] == 0) {
                    } else {
                        providergroup = 1; // Set provider group flag
                    }
                }
                if (object[i][0] == 'Sort' && providergroup == 0) {
                    if (object[i][1] == '1') {
                        string2 = string2 + '&sort[ClientId]='; // Sort by ClientId
                    } else {
                        if (object[i][1] == '2') {
                            string2 = string2 + '&sort[CreatedLocal]='; // Sort by CreatedLocal
                        } else {
                            if (object[i][1] == '3') {
                                string2 = string2 + '&sort[Amount]='; // Sort by Amount
                            }
                        }
                    }
                }
                if (object[i][0] == 'Dir' && providergroup == 0) {
                    if (object[i][1] == '0') {
                        string2 = string2 + 'asc'; // Ascending order
                    } else {
                        if (object[i][1] == '1') {
                            string2 = string2 + 'desc'; // Descending order
                        }
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        if (object[i][0] != 'Sort' && object[i][0] != 'Dir' && object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to query
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to query
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested filter data to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (providergroup == 0) {
                gridppal.show(); // Show main data table
                grid2.hide(); // Hide secondary data table
                gridppal.clearAll(); // Clear previous data
                gridppal
                    .load(url + '?start=0&count=' + gridppal.data.$pagesize + string1 + string2) // Load data with filters
                    .then(function (data) {
                        data = data.json(); // Parse response data
                        var columnsGrid = [];
                        gridppal.config.columns.forEach((item) => {
                            columnsGrid.push(item.id); // Collect column IDs
                        });
                        var difference = columnsGrid.filter((x) => Object.keys(data.data[0]).indexOf(x) === -1); // Check for missing columns
                        if (difference.length > 0) {
                            difference.forEach((id) => {
                                if (id != 'detailTittle') {
                                    gridppal.hideColumn(id); // Hide missing columns
                                }
                            });
                            gridppal.refreshColumns(); // Refresh column visibility
                        }
                    });
                $$('toolbar').show(); // Show toolbar
                $$('toolbar2').hide(); // Hide secondary toolbar
            } else {
                if (screen.width > 500 && screen.height > 500) {
                    $$('dColl').collapse(); // Collapse details section if screen size is large
                }
                grid2.show(); // Show secondary data table
                gridppal.hide(); // Hide main data table
                grid2.clearAll(); // Clear previous data
                grid2.load(url2 + '?start=0&count=' + grid2.data.$pagesize + string1 + string2).then(function (data) {
                    data = data.json(); // Parse response data
                    var columnsGrid = [];
                    grid2.config.columns.forEach((item) => {
                        columnsGrid.push(item.id); // Collect column IDs
                    });
                    var difference = columnsGrid.filter((x) => Object.keys(data.data[0]).indexOf(x) === -1); // Check for missing columns
                    if (difference.length > 0) {
                        difference.forEach((id) => {
                            grid2.hideColumn(id); // Hide missing columns
                        });
                        grid2.refreshColumns(); // Refresh column visibility
                    }
                });
                grid2.adjust(); // Adjust secondary table layout
                $$('toolbar2').show(); // Show secondary toolbar
                $$('toolbar').hide(); // Hide main toolbar
            }
            filter = string1 + string2; // Update filter variable
            $$('filterPopup').hide(); // Hide filter popup
        });
        this.on(this.app, 'export:filter', (filterData) => {
            console.log(filterData); // Log filter data for export
            flag = true; // Set export flag
            var firstfirst;
            if (filterData.first == 0) {
                firstfirst = filterData.first + 1; // Adjust first index for export
            } else {
                firstfirst = filterData.first;
            }
            gridppal.load(url + '?start=' + firstfirst + '&count=' + (filterData.last + 1) + filter); // Load data for export
            $$('datatable4').attachEvent(
                'onAfterLoad',
                function () {
                    if (flag) {
                        var size = $$('datatable4').getPager().config.size; // Get page size
                        var page = $$('datatable4').getPage(); // Get current page
                        var first = size * page; // Calculate first item index
                        var last = first + size - 1; // Calculate last item index
                        if ($$('Export').getValue() == '1') {
                            for (var j = 0; j < gridppal.config.columns.length; j++) {
                                if (gridppal.config.columns[j].exportType) {
                                    delete gridppal.config.columns[j].format; // Remove format for export
                                }
                            }
                            this.app.callEvent('export:data', [
                                {
                                    NameReport:
                                        'Depósitos' +
                                        ($$('datatable4').count() > 0 ? '' : _(' - No hay datos')) +
                                        ' - ' +
                                        new Date().toLocaleString(), // Report name for Excel export
                                    TypeReport: 'Excel', // Type of report
                                },
                            ]);
                            webix.toExcel(gridppal, {
                                filter: function (obj) {
                                    return (
                                        $$('datatable4').getIndexById(obj.id) >= first &&
                                        $$('datatable4').getIndexById(obj.id) <= last
                                    ); // Filter for export
                                },
                                filename:
                                    'Virtualsoft - ' +
                                    new Date()
                                        .toLocaleString('en-GB', {
                                            hour12: true,
                                        })
                                        .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                        .replace(/[\/:]/g, '_')
                                        .toUpperCase() +
                                    ' - ' +
                                    ($$('datatable4').count() > 0 ? '' : _('No hay datos - ')) +
                                    'Depósitos', // Filename for export
                                ignore: { detailTittle: true }, // Ignore detail title in export
                                footer: false, // Do not include footer in export
                            });
                        } else {
                            if ($$('Export').getValue() == '2') {
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            'Depósitos' +
                                            ($$('datatable4').count() > 0 ? '' : _(' - No hay datos')) +
                                            ' - ' +
                                            new Date().toLocaleString(), // Report name for PDF export
                                        TypeReport: 'PDF', // Type of report
                                    },
                                ]);
                                webix.toPDF($$('datatable4'), {
                                    filter: function (obj) {
                                        return (
                                            $$('datatable4').getIndexById(obj.id) >= first &&
                                            $$('datatable4').getIndexById(obj.id) <= last
                                        ); // Filter for export
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable4').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Depósitos', // Filename for export
                                    autowidth: true, // Auto width for PDF
                                    ignore: { detailTittle: true }, // Ignore detail title in export
                                    footer: false, // Do not include footer in export
                                });
                            }
                        }
                        flag = false; // Reset export flag
                        $$('Export').setValue(''); // Reset export selection
                    }
                }.bind(this),
            );
        });
        gridppal.attachEvent('onAfterSort', function (by, dir, as) {
            console.log('as: ' + as); // Log sorting information
            gridppal.load(url + '?start=0&count=' + gridppal.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });
        grid2.attachEvent('onAfterSort', function (by, dir, as) {
            grid2.load(url + '?start=0&count=' + grid2.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });
        this.on(this.app, 'player:select', (Id) => {
            gridppal.load(gridppal.data.url + '?start=0&count=' + gridppal.data.$pagesize + '&PlayerId=' + Id); // Load data based on selected player
        });
    }
}

// FILE DOCUMENTED
